import api from '@mint-lib/api';
import { useTranslation } from '@mint-lib/i18n';
import { useMutation } from '@mint-lib/query-client';

import { invalidateBuyingPlanInfo } from '../api/mediaPlansApiSlice.js';
import { UpdateCellPayload } from '../types/buyingPlanInfo.js';
import { extractMessageFromError, isAxiosError } from '../utils/helpers.js';
import useSimpleNotification from './useSImpleNotification.js';

const updateCellData = async ({ rowId, ...rest }: UpdateCellPayload) => {
  const response = await api.put(
    `api/datintell/v1/builder/media_plan_items/${rowId}/`,
    rest,
  );

  return response;
};

export const useBuilderTableCellMutation = () => {
  const { t } = useTranslation('@myn/planning');
  const mutation = useMutation({
    mutationFn: (payload: UpdateCellPayload) => updateCellData(payload),
    onSuccess: invalidateBuyingPlanInfo,
  });
  const { showErrorNotification } = useSimpleNotification();

  const onError = (error: unknown) => {
    const isValidationError =
      isAxiosError(error) && error.response?.status === 400;

    if (isValidationError) {
      showErrorNotification({
        title: 'Error',
        subTitle: extractMessageFromError(error.response?.data, t),
      });
    }
  };

  const updateCellValue = async (payload: UpdateCellPayload) => {
    try {
      await mutation.mutateAsync(payload);
    } catch (error) {
      onError(error);
      throw error;
    }
  };

  return updateCellValue;
};
